import type {AppThunk} from '../../../../actions/types'
import {getAgentPreviewsArg} from '../../../../rest/agents'
import {loadEndpoint} from '../../../../routes/loadEndpoint'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import {restApi} from '../../../../services/rest'

import {preloadAgentsTabs} from './useAgentsTabs.preload'

export const preloadAgentsOverviewPage = (): AppThunk<LoadedEndpoints> => dispatch => [
  ...dispatch(preloadAgentsTabs()),
  dispatch(loadEndpoint(restApi.endpoints.getAllAgentPreviewsNormalized, getAgentPreviewsArg())),
]
